import * as yup from 'yup'
import { TYPE_REQUIRED } from 'constants/errors'
import { routingNumberSchema, accountNumberSchema, bankAccountTypeSchema, YupShape } from 'helpers/schemaHelpers'

type AmountStepFields = {
  amount: number
}

type AccountStepFields = {
  bank_account_type: string
  routing_number: number
  account_number: number
  remember?: boolean
  name?: string
}

const amountStep = {
  amount: yup.number().required(TYPE_REQUIRED),
}
export const amountStepSchema = yup.object().shape<YupShape<AmountStepFields>>(amountStep)

const accountStep = {
  bank_account_type: bankAccountTypeSchema,
  routing_number: routingNumberSchema,
  account_number: accountNumberSchema,
  remember: yup.boolean(),
  name: yup.string().max(32),
}

// @ts-expect-error -- Weird yup behavior with Typescript. Needs research. https://github.com/jquense/yup/issues/1183
export const accountStepSchema = yup.object().shape<YupShape<AccountStepFields>>(accountStep)

// @ts-expect-error -- Leads to TS2589 Type instantiation is excessively deep and possibly infinite.
export const confirmationStepSchema = yup.object().shape({ ...amountStep, ...accountStep })

// Default export uses confirmationStepSchema, because it includes all the fields
export default confirmationStepSchema
